import { render, staticRenderFns } from "./LifetimeSamples.vue?vue&type=template&id=5620cd34&scoped=true"
import script from "./LifetimeSamples.vue?vue&type=script&lang=js"
export * from "./LifetimeSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620cd34",
  null
  
)

export default component.exports